<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-table
          striped
          hover
          responsive
          :per-page="perPage"
          :items="items"
          :fields="fields"
          @row-clicked="Click"
        >
          <template #cell(From)="data">
            {{ formatDate(data.item.From) }}
          </template>
          <template #cell(To)="data">
            {{ formatDate(data.item.To) }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {

      fields: [
        {
          key: 'IdentId',
          label: 'PlanId',
        },
        {
          key: 'Name',
          label: 'Name',
        },
        {
          key: 'From',
          label: 'Von',
        },
        {
          key: 'To',
          label: 'Bis',
        }
      ],
      items: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Flugliste'
    })
    this.LoadList()

  },
  methods: {
    Click(record, index) {
      this.$router.push({
        name: 'FlightList',
        params: { id: record.IdentId }
      })
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          },
      )}`
    },
    LoadList() {
      this.items = []
      this.$http.get('/flightPlan/plans')
        .then(resp => {
          this.totalRows = resp.data.info.fullEntries
          resp.data.list.forEach(i => {
            this.items.push(i)
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>
